import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { logEvent, getAnalytics } from 'firebase/analytics';
import MultiStepActivationContainer from './Components/MultiStepActivationContainer';
import { useTranslation, Trans } from 'react-i18next';
import i18n from 'i18next';
import images from '../Theming/images';
import { useHistory } from 'react-router-dom';
import { Path } from '../Routing';
import app from '../Firebase';
import { usePageViewTracking, useQuery } from '../Common/Hooks';
import {
  ANALYTICS_ACTION_LABELS,
  ANALYTICS_PAGE_NAMES,
  trackActivationActionEvent,
} from '../Common/Analytics/utils';

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const BodyContentContainer = styled.div`
  width: 100%;
  margin-top: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
`;

const StyledImage = styled.img`
  position: fixed;
  top: 8px;
  right: 20px;
  animation: ${bounce} 2s infinite;
  width: 261px;
  height: 60px;
  z-index: 2;
`;

const TextContainer = styled.div`
  color: white;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 20px;
`;

const PartnerNewPluginActivateTimMultiStepAlwaysAllow = () => {
  usePageViewTracking(ANALYTICS_PAGE_NAMES.additional_permissions_page, 'TIM');
  if (i18n.language != 'it') {
    i18n.changeLanguage('it');
  }
  const { t } = useTranslation();
  const history = useHistory();
  const query = useQuery();
  const { activation_permissions } = ANALYTICS_ACTION_LABELS;
  const { additional_permissions_page } = ANALYTICS_PAGE_NAMES;

  useEffect(() => {
    const analytics = getAnalytics(app);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const messageHandler = (message: any) => {
      if (message && message.data === '') {
        window.location.reload();
      } else if (message) {
        switch (message.data?.type) {
          case 'PluginEnabled': {
            trackActivationActionEvent(
              query,
              'TIM',
              activation_permissions,
              additional_permissions_page,
              {
                permissions: message.data?.givenPermission ? 'Full' : 'Partial',
              }
            );
            logEvent(analytics, 'activation_permissions', {
              permissions: message.data?.givenPermission ? 'Full' : 'Partial',
              partner: 'TIM',
            });

            if (message.data?.givenPermission) {
              history.push({
                pathname: Path.TimPluginActivationStartShopping,
                search: location.search,
              });
            } else {
              history.push({
                pathname: Path.TimPluginActivationPartialPermissions,
                search: location.search,
              });
            }
            break;
          }
        }
      }
    };

    window.addEventListener('message', messageHandler);

    return () => window.removeEventListener('message', messageHandler);
  }, [history]);

  return (
    <MultiStepActivationContainer
      bodyMarginTop={25}
      image={images.partnerpluginsdk_activation_tim_review?.default}
    >
      <StyledImage src={images.tim_ios_review_permissions?.default} />
      <BodyContentContainer>
        <TextContainer>
          <Trans
            i18nKey="PartnerNewpluginsdkActivate.timReviewPermissionsTapReview"
            t={t}
          />
        </TextContainer>
        <TextContainer>
          <Trans
            i18nKey="PartnerNewpluginsdkActivate.timReviewPermissionsSelectAllow"
            t={t}
          />
        </TextContainer>
        <TextContainer>
          <Trans
            i18nKey="PartnerNewpluginsdkActivate.timReviewPermissionsSelectAllowForAllWebsites"
            t={t}
          />
        </TextContainer>
      </BodyContentContainer>
    </MultiStepActivationContainer>
  );
};

export default PartnerNewPluginActivateTimMultiStepAlwaysAllow;
